module.exports = __webpack_public_path__ + "img/spring_02.88382f3d.png";